/* NUVA — Sistema editorial (Fase 1). Sin librerías externas.
   - Apariciones al desplazarse ([data-nve-reveal]); sin JS o con movimiento
     reducido, todo queda visible.
   - Tarjetas con segunda foto: en pantallas táctiles, botón que alterna la foto.
   - Kits y matriz de beneficios: leen snippets/nuva-kit-config.liquid (fuente
     única). No se repite ninguna cifra aquí; precio y enlaces los pone Liquid. */
(function () {
  'use strict';
  if (window.__nveInit) return;
  window.__nveInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RANK = { start: 1, growth: 2, store: 3, business: 4, ecommerce: 5 };
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function kitConfig() {
    var s = document.querySelector('script[data-nuva-kit-config]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  /* ---------- Apariciones ---------- */
  var io = null;
  function initReveals(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-nve-reveal]:not(.is-in)'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // Lo que ya está en pantalla al cargar se marca ANTES de activar el modo
    // animado (clase nve-js), así no parpadea ni se vuelve a animar.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('is-in');
    });
    document.documentElement.classList.add('nve-js');
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------- Tarjetas: segunda foto sin depender del hover ---------- */
  function initCards(root) {
    root.querySelectorAll('[data-nve-card-toggle]').forEach(function (btn) {
      if (btn.dataset.nveInit) return;
      btn.dataset.nveInit = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-nve-card]');
        if (!card) return;
        var on = card.classList.toggle('is-alt');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  /* ---------- Kits ---------- */
  function catLabel(cat, n) {
    if (cat.key === 'calcetasPacks') return n === 1 ? 'pack de calcetas (3 pares)' : 'packs de calcetas (3 pares c/u)';
    return String(cat.label || cat.key).toLowerCase();
  }
  function compositionHtml(kit, cats) {
    var parts = [];
    (cats || []).forEach(function (cat) {
      var n = kit.composition && kit.composition[cat.key];
      if (n) parts.push('<strong>' + esc(n) + '</strong> ' + esc(catLabel(cat, n)));
    });
    var html = parts.join(' · ');
    if (kit.piezasFisicas) html += (html ? '<br>' : '') + '<strong>' + esc(kit.piezasFisicas) + '</strong> piezas en total';
    return html;
  }
  function initKits(root, cfg) {
    var kits = cfg.kits || [];
    root.querySelectorAll('[data-nve-kit]').forEach(function (card) {
      if (card.dataset.nveInit) return;
      var id = card.getAttribute('data-nve-kit');
      var idx = -1;
      kits.forEach(function (k, i) { if (k.id === id) idx = i; });
      if (idx < 0) return;
      card.dataset.nveInit = '1';
      var kit = kits[idx];
      var prev = idx > 0 ? kits[idx - 1] : null;

      var tag = card.querySelector('[data-nve-kit-tagline]');
      if (tag && kit.tagline) { tag.textContent = kit.tagline; tag.hidden = false; }

      var comp = card.querySelector('[data-nve-kit-comp]');
      if (comp) { var ch = compositionHtml(kit, cfg.categories); if (ch) { comp.innerHTML = ch; comp.hidden = false; } }

      var chip = card.querySelector('[data-nve-kit-custom]');
      if (chip && kit.customizable) chip.hidden = false;

      var list = card.querySelector('[data-nve-kit-recursos]');
      var sum = card.querySelector('[data-nve-kit-sum]');
      if (list) {
        var items = kit.recursos || [];
        if (prev && card.getAttribute('data-nve-kit-diff') !== 'false') {
          var before = prev.recursos || [];
          items = items.filter(function (r) { return before.indexOf(r) === -1; });
          /* "Todo lo de…, más:" solo si de verdad hay herramientas nuevas (p. ej. Growth suma inventario, no herramientas) */
          if (sum && items.length) { sum.textContent = 'Todo lo de ' + prev.name + ', más:'; sum.hidden = false; }
        }
        if (items.length) {
          list.innerHTML = items.map(function (r) { return '<li>' + esc(r) + '</li>'; }).join('');
          list.hidden = false;
        }
      }
    });
  }

  /* ---------- Matriz de beneficios por nivel ---------- */
  function initMatrix(root, cfg) {
    root.querySelectorAll('[data-nve-matrix]').forEach(function (mount) {
      if (mount.dataset.nveInit) return;
      mount.dataset.nveInit = '1';
      var kits = cfg.kits || [];
      if (!kits.length) return;

      // Filas "Tu kit": unión de recursos en el orden en que aparecen por primera vez.
      var rows = [];
      kits.forEach(function (k) {
        (k.recursos || []).forEach(function (r) { if (rows.indexOf(r) === -1) rows.push(r); });
      });

      // Filas "Mi negocio NUVA": vienen de la sección (bloques con plan mínimo).
      var portal = [];
      var src = mount.parentNode.querySelector('script[data-nve-portal-matrix]');
      if (src) { try { portal = JSON.parse(src.textContent) || []; } catch (e) { portal = []; } }

      var yes = '<span class="nve-matrix__yes">' + CHECK + '</span><span class="nve-sr-only">Incluido</span>';
      var no = '<span class="nve-matrix__no" aria-hidden="true">—</span><span class="nve-sr-only">No incluido</span>';
      var cols = kits.length + 1;

      var html = '<table class="nve-matrix"><caption class="nve-sr-only">Qué incluye cada nivel NUVA</caption><thead><tr><th scope="col">Incluye</th>';
      kits.forEach(function (k) {
        html += '<th scope="col">' + esc(String(k.name || k.id).replace(/^NUVA\s+/i, '')) + '</th>';
      });
      html += '</tr></thead><tbody>';
      html += '<tr class="nve-matrix__group"><th scope="rowgroup" colspan="' + cols + '">' + esc(mount.getAttribute('data-label-kit') || 'Tu kit') + '</th></tr>';
      rows.forEach(function (r) {
        html += '<tr><th scope="row">' + esc(r) + '</th>';
        kits.forEach(function (k) { html += '<td>' + ((k.recursos || []).indexOf(r) !== -1 ? yes : no) + '</td>'; });
        html += '</tr>';
      });
      if (portal.length) {
        html += '<tr class="nve-matrix__group"><th scope="rowgroup" colspan="' + cols + '">' + esc(mount.getAttribute('data-label-portal') || 'En Mi negocio NUVA') + '</th></tr>';
        portal.forEach(function (p) {
          var min = RANK[p.min] || 1;
          html += '<tr><th scope="row">' + esc(p.name) + '</th>';
          kits.forEach(function (k) { html += '<td>' + ((RANK[k.id] || 0) >= min ? yes : no) + '</td>'; });
          html += '</tr>';
        });
      }
      html += '</tbody></table>';
      mount.innerHTML = html;
    });
  }

  /* ---------- Acompañamiento (ancla #acompanamiento) ---------- */
  function initAcomp(root, cfg) {
    var a = cfg.acompanamiento;
    if (!a) return;
    root.querySelectorAll('[data-nve-acomp]').forEach(function (box) {
      if (box.dataset.nveInit) return;
      box.dataset.nveInit = '1';
      var set = function (sel, val) { var el = box.querySelector(sel); if (el && val) { el.textContent = val; el.hidden = false; } };
      set('[data-nve-acomp-nombre]', a.nombre);
      set('[data-nve-acomp-meta]', [a.frecuencia, a.aplicaA].filter(Boolean).join(' · '));
      set('[data-nve-acomp-desc]', a.descripcion);
      var temas = box.querySelector('[data-nve-acomp-temas]');
      if (temas && a.temas && a.temas.length) {
        temas.innerHTML = a.temas.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
        temas.hidden = false;
      }
    });
  }

  /* ---------- Hero en pantalla: en móvil el CSS oculta los botones flotantes ---------- */
  var heroIo = null;
  function initHeroVisible(root) {
    var hero = root.querySelector('.nve-hero--split');
    if (!hero || hero.dataset.nveVisible || !('IntersectionObserver' in window)) return;
    hero.dataset.nveVisible = '1';
    if (heroIo) heroIo.disconnect();
    heroIo = new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('nve-hero-en-pantalla', entries[0].isIntersecting);
    }, { threshold: 0 });
    heroIo.observe(hero);
  }

  /* ---------- Tarjetas de kits en pantalla: en móvil/tableta el CSS oculta los botones flotantes
     para que no tapen las fotos ni el botón "Ver kit" (clase propia, independiente del hero) ---------- */
  var kitsIo = null;
  function initKitsVisible(root) {
    /* la tarjeta destacada (Start) va fuera de la cuadrícula: se vigilan ambas.
       Carrito (Fase 4): también los botones de pago, para que los flotantes no tapen "Pagar". */
    var zonas = [].slice.call(root.querySelectorAll('.nve-kit--featured, .nve-kits__grid, .cart__ctas'));
    if (!zonas.length || zonas[0].dataset.nveVisible || !('IntersectionObserver' in window)) return;
    zonas.forEach(function (z) { z.dataset.nveVisible = '1'; });
    if (kitsIo) kitsIo.disconnect();
    var visibles = new Set();
    kitsIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target); });
      document.documentElement.classList.toggle('nve-kits-en-pantalla', visibles.size > 0);
    }, { threshold: 0 });
    zonas.forEach(function (z) { kitsIo.observe(z); });
  }

  function init(root) {
    initReveals(root);
    initCards(root);
    initHeroVisible(root);
    initKitsVisible(root);
    var cfg = kitConfig();
    if (cfg) { initKits(root, cfg); initMatrix(root, cfg); initAcomp(root, cfg); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Editor de temas: re-inicializa la sección que Shopify vuelve a pintar.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
